import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusEnergy = (props) => {
    const width = props.width ? props.width + 'px' : '55px';
    const height = props.height ? props.height + 'px' : '45px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 55 45"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.1875 0H25.7067V0.014607H24.7461V37.3794H28.1365V3.28658H40.1875V0ZM55 40.4214H0V44.3014H55V40.4214ZM34.6426 6.646H44.7347V10.526H34.6426V6.646Z"
            />
        </SvgStyled>
    );
};

export default CampusEnergy;
